<template>
  <Head title="Subscriptions / Proposals" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <subscription-list />
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';
</script>

